// extracted by mini-css-extract-plugin
export default {"page":"fY-z","cartModal":"gY-z","checkout":"hY-z","placeholder":"iY-z","account":"jY-z"};